import { render, staticRenderFns } from "./RelativeValue.vue?vue&type=template&id=60d4203c&scoped=true&"
import script from "./RelativeValue.vue?vue&type=script&lang=js&"
export * from "./RelativeValue.vue?vue&type=script&lang=js&"
import style0 from "./RelativeValue.vue?vue&type=style&index=0&id=60d4203c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4203c",
  null
  
)

export default component.exports